export enum GameTypes {
  RNG = 'rng',
  NON_RNG = 'nonRng',
  TRIVIA = 'trivia',
  ADVENT_CALENDAR = 'adventCalendar',
  POLL = 'poll',
  COMMUNITY_GAME = 'communityGame'
}
